import { useEffect } from 'react'
import * as Sentry from '@sentry/browser'
import { AccountType } from 'types/accounts'
import { version } from '../../../package.json'

const useSentryContext = (account: AccountType) => {
  const { id: accountId, reference } = account || {}

  useEffect(() => {
    if (!Sentry) return

    Sentry.setTags({
      accountId: accountId?.toString() || 'unknown',
      accountReference: reference || 'unknown',
      appVersion: version,
    })
  }, [account, version, Sentry])
}

export default useSentryContext
